import { render, staticRenderFns } from "./SupplierCreate.vue?vue&type=template&id=18c7831c&scoped=true"
import script from "./SupplierCreate.vue?vue&type=script&lang=js"
export * from "./SupplierCreate.vue?vue&type=script&lang=js"
import style0 from "./SupplierCreate.vue?vue&type=style&index=0&id=18c7831c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7831c",
  null
  
)

export default component.exports